import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * DIVERGES FROM UPSTREAM shadcn - do not overwrite with `add sonner`.
 *
 * The generated version imports `useTheme` from `next-themes`. These are Vite
 * apps with their own ThemeProvider, and pulling in next-themes would mean two
 * theme systems disagreeing about what is on screen.
 *
 * So the theme is read from the `.dark` class on <html> - the same thing every
 * other shadcn component responds to - which keeps one source of truth and one
 * dependency fewer. The `'use client'` directive is dropped for the same
 * reason: there are no server components here.
 */
function useDocumentTheme(): ToasterProps['theme'] {
  if (typeof document === 'undefined') return 'system';
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}

const Toaster = ({ ...props }: ToasterProps) => {
  const theme = useDocumentTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
